import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrdersTreeListRefreshService {
  private readonly refreshSubject = new Subject<void>();
  readonly refresh$: Observable<void> = this.refreshSubject.asObservable();

  refresh(): void {
    this.refreshSubject.next();
  }
}
